export const createReducer =
  ({ initialState, actionsRepo }) =>
  (state = initialState, { type, payload }) =>
    !!actionsRepo[type] ? actionsRepo[type](state, payload) : state;
